import { createSlice } from '@reduxjs/toolkit';
import type { ISTasksContextResponse, OverviewUpload } from '@api/isTasks';
import { createSliceHook, makeActionCreator } from '@restore/helpers';

type State = {
  data: ISTasksContextResponse | null;
  tasks: OverviewUpload[] | null;
  dicomResource: string | null;
};

const initialState: State = {
  data: null,
  tasks: null,
  dicomResource: null,
};

const { act } = makeActionCreator<State>();

export const SimpleViewerSlice = createSlice({
  name: 'SimpleViewer',
  initialState,
  reducers: {
    setData: act((data: ISTasksContextResponse) => ({ data })),
    setTasks: act((tasks: OverviewUpload[]) => ({ tasks })),
    setDicomResource: act((dicomResource: string) => ({ dicomResource })),
  },
});

export const useSimpleViewerSlice = createSliceHook(
  SimpleViewerSlice.name,
  SimpleViewerSlice.actions
);
